import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tab',
  standalone: true,
  imports: [CommonModule],
  template: `
      <ng-template #contentTemplate>
          <ng-content></ng-content>
      </ng-template>
  `,
  styles: ['']
})
export class TabWidgetComponent {
  @Input() title: string = '';
  @Input() active: boolean = false;
  @Input() disabled: boolean = false; // New input for disabled state
  @Input() iconSrc: string = ''; // Image source URL
  @Input() iconAlt: string = ''; // Alt text for the image
  @Input() chips: string = ''; // Alt text for the image

  @ViewChild('contentTemplate', { static: true }) contentTemplate!: TemplateRef<any>;
}